import { motion } from "framer-motion";

const testimonials = [
    {
        id: 1,
        name: "Emily Carter",
        role: "Pasien",
        content:
            "Pelayanan di klinik ini sangat ramah dan teratur. Sistem antriannya memudahkan saya memantau giliran tanpa harus menunggu lama.",
        stars: 5,
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=150&auto=format&fit=crop",
    },
    {
        id: 2,
        name: "Daniel Roberts",
        role: "Pasien",
        content:
            "Antrian menjadi lebih teratur dan ruang tunggu terasa lebih nyaman. Sangat membantu ketika klinik sedang ramai.",
        stars: 5,
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=150&auto=format&fit=crop",
    },
    {
        id: 3,
        name: "Sophia Martinez",
        role: "Pasien",
        content:
            "Proses pendaftaran dan pengambilan nomor antrian sangat praktis. Pelayanan dokter juga profesional dan jelas saat memberikan penjelasan.",
        stars: 5,
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=150&auto=format&fit=crop",
    },
];

function CareLineTestimonials() {
    return (
        <section className="relative overflow-hidden py-16 md:py-20 font-[Plus_Jakarta_Sans,sans-serif]">
            <div className="absolute inset-0 pointer-events-none z-0">
                <img
                    src="/patterns/careline-testimony-pattern.svg"
                    alt=""
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="relative z-10 mx-auto max-w-[1280px] px-4 sm:px-6 md:px-10 lg:px-16 xl:px-[60px]">
                <motion.div
                    className="flex flex-col items-center text-center mb-10 md:mb-12"
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{
                        duration: 0.7,
                        ease: [0.25, 0.46, 0.45, 0.94],
                    }}
                >
                    <div className="inline-flex items-center gap-2 bg-cyan-50 border border-cyan-200/70 text-cyan-600 text-[11px] font-bold px-3.5 py-1.5 rounded-full uppercase tracking-[0.08em] mb-5">
                        <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full" />
                        Testimoni Pasien
                    </div>
                    <h2 className="text-[clamp(24px,3.5vw,40px)] font-extrabold text-gray-900 leading-tight tracking-[-0.02em] mb-3">
                        Pengalaman Pasien di{" "}
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#06B6D4] to-[#0891B2]">
                            Klinik
                        </span>{" "}
                        Kami
                    </h2>
                    <p className="text-gray-400 text-[15px] max-w-sm leading-relaxed font-medium">
                        Pengalaman pasien dalam menggunakan layanan kesehatan
                        dan sistem antrian kami.
                    </p>
                </motion.div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {testimonials.map((item, idx) => (
                        <motion.div
                            key={item.id}
                            className="group relative flex flex-col bg-white rounded-[18px] px-6 pt-6 pb-6 border border-[#e8f4f8] overflow-hidden"
                            initial={{ opacity: 0, y: 36 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.2 }}
                            transition={{
                                duration: 0.6,
                                delay: idx * 0.12,
                                ease: [0.25, 0.46, 0.45, 0.94],
                            }}
                            whileHover={{
                                y: -6,
                                boxShadow:
                                    "0 8px 16px rgba(0,0,0,0.05), 0 24px 48px rgba(6,182,212,0.10)",
                                borderColor: "rgba(6,182,212,0.2)",
                            }}
                        >
                            <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#06B6D4] to-[#67e8f9] rounded-t-[18px] scale-x-0 origin-left transition-transform duration-[350ms] group-hover:scale-x-100" />
                            <div className="flex items-start justify-between mb-5">
                                <svg
                                    width="28"
                                    height="22"
                                    viewBox="0 0 40 30"
                                    fill="none"
                                >
                                    <defs>
                                        <linearGradient
                                            id="quoteGrad"
                                            x1="0"
                                            y1="0"
                                            x2="1"
                                            y2="1"
                                        >
                                            <stop
                                                offset="0%"
                                                stopColor="#06B6D4"
                                            />
                                            <stop
                                                offset="100%"
                                                stopColor="#0891B2"
                                            />
                                        </linearGradient>
                                    </defs>
                                    <path
                                        d="M0 19.5C0 13.5 3.5 7.5 10.5 3L13 6.5C9 9 7 12 6.5 15.5C7.2 15.2 8 15 9 15C12.3 15 15 17.7 15 21C15 24.3 12.3 27 9 27C4.5 27 0 23.5 0 19.5Z"
                                        fill="url(#quoteGrad)"
                                    />
                                    <path
                                        d="M22 19.5C22 13.5 25.5 7.5 32.5 3L35 6.5C31 9 29 12 28.5 15.5C29.2 15.2 30 15 31 15C34.3 15 37 17.7 37 21C37 24.3 34.3 27 31 27C26.5 27 22 23.5 22 19.5Z"
                                        fill="url(#quoteGrad)"
                                    />
                                </svg>
                                <div className="flex gap-0.5">
                                    {[...Array(item.stars)].map((_, i) => (
                                        <svg
                                            key={i}
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                        >
                                            <defs>
                                                <linearGradient
                                                    id={`sg${item.id}_${i}`}
                                                    x1="0"
                                                    y1="0"
                                                    x2="1"
                                                    y2="1"
                                                >
                                                    <stop
                                                        offset="0%"
                                                        stopColor="#FDE68A"
                                                    />
                                                    <stop
                                                        offset="100%"
                                                        stopColor="#F59E0B"
                                                    />
                                                </linearGradient>
                                            </defs>
                                            <path
                                                fill={`url(#sg${item.id}_${i})`}
                                                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                                            />
                                        </svg>
                                    ))}
                                </div>
                            </div>
                            <div className="w-full h-px bg-gradient-to-r from-cyan-100 to-transparent mb-5" />
                            <p className="text-gray-400 text-[13px] leading-relaxed font-medium flex-1 mb-6">
                                {item.content}
                            </p>
                            <div className="flex items-center gap-3 mt-auto">
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="w-9 h-9 rounded-full object-cover flex-shrink-0 ring-2 ring-cyan-100"
                                />
                                <div>
                                    <h4 className="text-[13px] font-bold text-gray-900 leading-snug">
                                        {item.name}
                                    </h4>
                                    <span className="text-[11.5px] text-gray-400 font-medium">
                                        {item.role}
                                    </span>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default CareLineTestimonials;